import {Component} from "react";
import type {ReactNode} from "react";
import {GoogleMap, InfoWindow, Marker} from '@react-google-maps/api';

export interface LocationMapMarker {
    position: google.maps.LatLng | google.maps.LatLngLiteral;
    icon?: string | google.maps.Icon | google.maps.Symbol;
    showInfo?: boolean;
    infoContent?: ReactNode;
}

interface LocationMapProps {
    onLoad: (map: google.maps.Map) => void;
    center?: google.maps.LatLng | google.maps.LatLngLiteral;
    zoom?: number;
    options?: google.maps.MapOptions;
    onClick?: (event: google.maps.MapMouseEvent) => void;
    markers: LocationMapMarker[];
    onMarkerClick?: (marker: LocationMapMarker) => void;
    onMarkerClose?: (marker: LocationMapMarker) => void;
}

const styles = {
    height: `265px`,
};

class LocationMap extends Component<LocationMapProps> {
    render() {
        const props = this.props
        return (
            <GoogleMap
                onLoad={(map) => {
                    props.onLoad(map);
                }}
                mapContainerStyle={styles}
                center={props.center}
                zoom={props.zoom}
                options={props.options}
                onClick={props.onClick}
            >
                {props.markers.map((marker, index) => (
                    <Marker
                        key={index}
                        position={marker.position}
                        onClick={() => props.onMarkerClick?.(marker)}
                        icon={marker.icon}
                        animation={google.maps.Animation.DROP}
                    >
                        {/*
                 Show info window only if the 'showInfo' key of the marker is true.
                 That is, when the Marker pin has been clicked and 'onCloseClick' has been
                 Successfully fired.
                 */}
                        {marker.showInfo && (
                            <InfoWindow onCloseClick={() => props.onMarkerClose?.(marker)}>
                                <div>{marker.infoContent}</div>
                            </InfoWindow>
                        )}
                    </Marker>
                ))}
            </GoogleMap>
        )
    }
}

export default LocationMap;
